import { connect } from 'react-redux';

import ScheduleTable from './ScheduleTable.jsx';

const mapStateToProps = (state) => ({
  shouldBeTableFocused: state.reducer.schedule.quickPlanning.position.borderCell.employeeId,
});

export default connect(mapStateToProps)(ScheduleTable);
